import { Component, OnInit } from '@angular/core';
import { CompanyService } from '../../../../services/company.service';
import { LocationService } from '../../../../services/location.service';
import { EquipmentService } from '../../../../services/equipment.service';
import { ManufacturerService } from '../../../../services/manufacturer.service';
import { CategoryService } from '../../../../services/category.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Equipment } from '../../../../models/equipment';
import { Equipment_Extra } from '../../../../models/equipment_Extra';
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-equipment-manage',
  templateUrl: './equipment-manage.component.html',
  styleUrls: ['./equipment-manage.component.css']
})
export class EquipmentManageComponent implements OnInit {

  companies;
  locations;
  manufacturers;
  categories;

  equipment;

  locationList;

  is_Crane;
  is_Jib;

  constructor(public companyService: CompanyService, public locationService: LocationService, public equipmentService: EquipmentService, manufacturerService: ManufacturerService,
    categoryService: CategoryService, public router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService) {
    this.equipment = new Equipment();

    manufacturerService.getAll().then((data) => {
      this.manufacturers = data;
    });

    categoryService.getAll().then((data) => {
      this.categories = data;
    });
  }

  onCompanyChange(value) {
    this.locations = this.locationList.filter(c => {
      return c.company_Id == value;
    });
  }

  ngOnInit() {
/*    this.companyService.getAll().then((data) => {
      this.companies = data;
      this.locationService.getAll().then((data) => {
        this.locationList = data;
        this.route.queryParams.subscribe(params => {
          const id = params['id'];
          if (id != undefined) {
            this.equipmentService.get(id).then((data) => {
              this.equipment = data;
              this.equipment.is_edit = true;
              this.locations = this.locationList.filter(c => {
                return c.company_Id == this.equipment.company_Id;
              });

              this.onCategoryChange(this.equipment.category_Id);
            });
          }
        });
      });
    });*/
  }

  onCategoryChange(value) {
    const category = this.categories.find(a => a.id == value);
    if (this.equipment.interval == null || this.equipment.interval == undefined || this.equipment.interval == 0) {
      this.equipment.interval = category.inspection_Interval;
    }

    if (category.name == 'Crane') {
      this.is_Crane = true;
      this.is_Jib = false;
    }
    else if (category.name == 'Jib') {
      this.is_Jib = true;
      this.is_Crane = false;
    } else {
      this.is_Crane = false;
      this.is_Jib = false;
    }
  }

  addExtra(is_Hoist) {
    const extra = new Equipment_Extra();
    extra.is_Hoist = is_Hoist;
    this.equipment.extras.push(extra);
  }

  removeExtra(extra) {
    this.equipment.extras.splice(this.equipment.extras.indexOf(extra), 1);
  }

  submit() {
    // Check if we have any extras and if so validate them
    for (const extra of this.equipment.extras) {
      if (extra.serial_Num == '' || extra.make == '') {
        this.snotifyService.warning('Please enter all hoist/cross information');
        return;
      }
    }
    console.log(this.equipment);
    this.equipmentService.save(this.equipment).then((data) => {
      this.router.navigate(['administration/equipment']);
    });
  }

}
